import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import InvoiceSettings from '../InvoiceSettings/page';

const InvoiceSettingsAc = ({ setHideFloatBtn }) => {
  const [expanded, setExpanded] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);
  useEffect(() => {
    if (expanded === true) {
      setHideFloatBtn(true);
    } else {
      setHideFloatBtn(false);
    }
  }, [expanded]);
  return (
    <Grid container>
      <Accordion
        expanded={expanded}
        onChange={() => {
          setExpanded(!expanded);
          setisLoaded(true);
        }}
        style={{ width: '100%', marginTop: '10px' }}
      >
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row', // Keep row direction
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontWeight: '600',
              fontSize: '18px',
            }}
          >
            Invoice Print Settings
          </Typography>
          <IconButton
            onClick={() => setExpanded(!expanded)}
            sx={{
              color: 'blue', // Customize color
              marginLeft: '8px', // Space between text and icon
              padding: '0px',
            }}
          >
            {expanded ? <CloseIcon /> : <AddIcon />}
          </IconButton>
        </AccordionSummary>
        <AccordionDetails>{isLoaded && <InvoiceSettings title={'set'} top={0} parent="settings" />}</AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default InvoiceSettingsAc;
